/* Theme-only quantity shortcuts. All prices and cart submissions remain Shopify-owned. */
if (!window.fadlashAnniversaryQuantityBound) {
  window.fadlashAnniversaryQuantityBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fa-quantity]');
    if (!button) return;
    const input = button.closest('form')?.querySelector('input[name="quantity"]');
    if (!input) return;
    input.value = button.dataset.faQuantity;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
